export default __webpack_public_path__ + "static/media/3.bb9518b6.png";